module.exports = __webpack_public_path__ + "static/media/gameHistory.37b6a480.svg";